export default __webpack_public_path__ + "static/media/5.c50c3672.webp";